import React, { useState, useEffect, useRef } from 'react';
import './ShortsVideo.css';
import { getAllShorts, likeDislikeShorts, getComments, addComment, deleteComment, deleteShortsVideo } from '../../api/shortsVideo';
import { submitVote, getVoteDetailsById, likeDislike } from '../../api/Vote';
import { getUser } from '../../api/auth';
import Cookies from 'js-cookie';
import FavoriteBorderRoundedIcon from '@mui/icons-material/FavoriteBorderRounded';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import KeyboardArrowUpRoundedIcon from '@mui/icons-material/KeyboardArrowUpRounded';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import CommentRoundedIcon from '@mui/icons-material/CommentRounded';
import ReplyRoundedIcon from '@mui/icons-material/ReplyRounded';
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import humanizeDuration from 'humanize-duration';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
import FaceRecognition from '../FaceRecognition/FaceRecognition';
import CloseIcon from '@mui/icons-material/Close';
import Loader from '../Loader';
import PermIdentityRoundedIcon from '@mui/icons-material/PermIdentityRounded';
import ShareIcon from '@mui/icons-material/Share';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import InfoOutlineRoundedIcon from '@mui/icons-material/InfoOutlineRounded';
import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded';
import NearMeOutlinedIcon from '@mui/icons-material/NearMeOutlined';
import { getUserId, getToken } from '../../api/index';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import { getHumanizedTime } from '../getHumanizedTime';
import SubscriptionPrompt from '../Shared/SubscriptionPrompt';
import ProfileCompletionPrompt from '../Shared/ProfileCompletionPrompt';
import { useSelector, useDispatch } from 'react-redux';
import { setUserDetails } from '../../Redux/Slices/userDetailsSlice';
import useGovtIdVerification from '../../hooks/useGovtIdVerification';
import ShareModal from '../Shared/ShareModal';

const ShortsVideo = () => {
  const [shortsVideo, setShortsVideo] = useState([]);
  const [openCommentVideoId, setOpenCommentVideoId] = useState(null);
  const [comments, setComments] = useState([]);
  const [commentText, setCommentText] = useState("");
  const commentBoxRef = useRef(null);
  const [shareDialogOpen, setShareDialogOpen] = useState(false);
  const [selectedVideoForShare, setSelectedVideoForShare] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [unmutedVideoId, setUnmutedVideoId] = useState(null);
  const [visibleVideoId, setVisibleVideoId] = useState(null);
  const videoRefs = useRef({});
  const [activeVoteResponse, setActiveVoteResponse] = useState(null);
  const [activeVoteDetails, setActiveVoteDetails] = useState(null);
  const [faceRecognitionDialogOpen, setFaceRecognitionDialogOpen] = useState(false);
  const [pendingVote, setPendingVote] = useState(null);
  const [isSignIn, setIsSignIn] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isUserVerified, setIsUserVerified] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(true);
  const [isSubscriptionEnable, setIsSubscriptionEnable] = useState(false);
  const [subscriptionDialogOpen, setSubscriptionDialogOpen] = useState(false);
  const [profilePromptOpen, setProfilePromptOpen] = useState(false);
  const [profilePromptMessage, setProfilePromptMessage] = useState('');
  // Help popup states
  const [showPopup, setShowPopup] = useState(false);
  const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
  const [selectedCardId, setSelectedCardId] = useState(null);
  const [selectedCreatorName, setSelectedCreatorName] = useState('');
  const [selectedCreatorUserId, setSelectedCreatorUserId] = useState('');
  const [isReportClicked, setIsReportClicked] = useState(false);
  const [playingVoteVideos, setPlayingVoteVideos] = useState({});
  const isTogglingCommentRef = useRef(false);
  const containerRef = useRef(null);
  const isScrollingRef = useRef(false);
  const scrollTimeoutRef = useRef(null);
  const [commentLoader, setCommentLoader] = useState(false);
  const [expandedDescriptions, setExpandedDescriptions] = useState({});
  
  // Redux hooks
  const dispatch = useDispatch();
  const storedUserDetails = useSelector((state) => state.userDetails?.userDetails);
  const govtHook = useGovtIdVerification();

  // Helper function to toggle description expansion for a specific video
  const toggleDescriptionExpansion = (videoId) => {
    setExpandedDescriptions(prev => ({
      ...prev,
      [videoId]: !prev[videoId]
    }));
  };

  // Helper function to get truncated description
  const getTruncatedDescription = (description, videoId, maxLength = 80) => {
    if (!description) return '';

    const isExpanded = expandedDescriptions[videoId];
    const shouldTruncate = description.length > maxLength;

    if (!shouldTruncate) {
      return description;
    }

    return isExpanded ? description : description.substring(0, maxLength) + '...';
  };

  // Helper function to get user initials
  const getUserInitials = (userName) => {
    if (!userName) return '';
    const words = userName.trim().split(' ');
    if (words.length === 1) {
      return words[0].charAt(0).toUpperCase();
    }
    const firstInitial = words[0] ? words[0].charAt(0).toUpperCase() : '';
    const lastInitial = words[words.length - 1] ? words[words.length - 1].charAt(0).toUpperCase() : '';
    return firstInitial + lastInitial;
  };

  // Helper function to generate background color based on initials
  const getBackgroundColor = (initials) => {
    const colors = [
      '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4',
      '#FFEAA7', '#DDA0DD', '#98D8C8', '#F7DC6F',
      '#BB8FCE', '#85C1E9', '#F8C471', '#82E0AA'
    ];

    let hash = 0;
    for (let i = 0; i < initials.length; i++) {
      hash = initials.charCodeAt(i) + ((hash << 5) - hash);
    }
    hash = Math.abs(hash);
    return colors[hash % colors.length];
  };

  useEffect(() => {
    if (activeVoteResponse) {
      try {
        const fetchVoteDetails = async () => {
          const credentials = {
            "voteId": activeVoteResponse,
            "userId": getUserId()
          }
          const response = await getVoteDetailsById(credentials, getToken());
          console.log("response from getVoteDetailsById api:", response);
          // if (response.isVoted === false) {

          setActiveVoteDetails(response);
          // } else {
          // setActiveVoteDetails(null);
          // }
        }
        fetchVoteDetails();
      } catch (error) {
        console.error("error in getVoteDetailsById:", error);
      }
    }
    return () => {
      setActiveVoteDetails(null);
    }
  }, [activeVoteResponse]);

  useEffect(() => {
    const token = getToken();
    const userId = getUserId();
    const getUserDetails = async () => {
      const response = await getUser(userId, token);
      console.log(" response from getUser api:", response.data);

      // Dispatch to Redux
      if (response?.data) {
        dispatch(setUserDetails(response.data));
      }

      if (response.data?.governmentId === null) {
        setIsUserVerified('notUploaded');
      } else if (response.data?.governmentId?.isVerified === true) {
        setIsUserVerified('verified');
      } else if (response.data?.governmentId?.verificationStatus === 'rejected') {
        setIsUserVerified('rejected');
      } else {
        setIsUserVerified('pending');
      }
      if (typeof response.data?.isSubscribed !== 'undefined') {
        setIsSubscribed(!!response.data.isSubscribed);
      }
      if (typeof response.data?.isSubscriptionEnable !== 'undefined') {
        setIsSubscriptionEnable(!!response.data.isSubscriptionEnable);
      }
    }
    getUserDetails();
  }, [dispatch]);

  // Keep local subscription state in sync with redux-stored user details
  useEffect(() => {
    if (storedUserDetails && typeof storedUserDetails.isSubscribed !== 'undefined') {
      setIsSubscribed(!!storedUserDetails.isSubscribed);
      setIsSubscriptionEnable(!!storedUserDetails.isSubscriptionEnable);
    }
  }, [storedUserDetails]);


  useEffect(() => {
    fetchShortsVideo();

    // Add click event listener
    const handleClickOutside = (event) => {
      // Skip if we're in the middle of toggling the comment box
      if (isTogglingCommentRef.current) {
        return;
      }

      if (commentBoxRef.current && !commentBoxRef.current.contains(event.target)) {
        setOpenCommentVideoId(null);
        setComments([]);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    // Cleanup listener
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      // Clear scroll timeout on cleanup
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, []);

  // Separate useEffect for scroll event listener
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    // Add scroll event listener to the container
    container.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      if (container) {
        container.removeEventListener('scroll', handleScroll);
      }
    };
  }, [shortsVideo.length]); // Re-attach when videos change

  useEffect(() => {
    // Create intersection observer
    const options = {
      root: null, // use viewport
      rootMargin: '0px',
      threshold: 0.7 // 70% of the video must be visible
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const videoId = entry.target.dataset.videoId;
        const videoElement = entry.target;

        if (entry.isIntersecting) {
          setVisibleVideoId(videoId);
          videoElement.play().catch(error => console.log("Playback failed:", error));
        } else {
          videoElement.pause();
          if (unmutedVideoId === videoId) {
            setUnmutedVideoId(null);
          }
        }
      });
    }, options);

    // Observe all video elements
    Object.values(videoRefs.current).forEach(videoElement => {
      if (videoElement) {
        observer.observe(videoElement);
      }
    });

    // Cleanup observer
    return () => {
      Object.values(videoRefs.current).forEach(videoElement => {
        if (videoElement) {
          observer.unobserve(videoElement);
        }
      });
    };
  }, [shortsVideo.length, unmutedVideoId]); // Re-run when videos are loaded or unmuted video changes

  const fetchShortsVideo = async () => {
    setIsLoading(true);
    const credentials = {
      "userId": getUserId(), // Updated to use utility function
      "skip": 0,
      "take": 10
    }
    try {
      const response = await getAllShorts(credentials, getToken()); // Updated to use utility function
      console.log("response from getAllShorts api:", response);
      setShortsVideo(response.data);
    } catch (error) {
      console.error('Error fetching shorts video:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const isProfileComplete = () => {
    const u = storedUserDetails;
    if (!u) return false;
    const hasName = !!((u.firstName && u.firstName.trim()) || (u.lastName && u.lastName.trim()) || u.displayName);
    const hasDob = !!u.dateOfBirth;
    const hasAddress = Array.isArray(u.addresses) ? u.addresses.length > 0 : !!u.address;
    return hasName && hasDob && hasAddress;
  };

  const guardAnd = () => {
    // Government ID presence check (only uploaded required)
    const govCheck = govtHook.check();
    if (!govCheck.allowed) {
      setProfilePromptMessage(govCheck.reason);
      setProfilePromptOpen(true);
      setSubscriptionDialogOpen(false);
      return false;
    }
    // Subscription check
    if (isSubscriptionEnable && !isSubscribed) {
      setSubscriptionDialogOpen(true);
      setProfilePromptOpen(false);
      return false;
    }
    setProfilePromptOpen(false);
    setSubscriptionDialogOpen(false);
    return true;
  };

  const handleLikeDislike = async (videoId) => {
    if (!guardAnd()) return;
    const token = getToken();
    const userId = getUserId();
    const credentials = {
      "userId": userId,
      "videoId": videoId
    }
    try {
      const response = await likeDislikeShorts(credentials, token);
      console.log("response from likeDislike api:", response);

      setShortsVideo(prevVideos =>
        prevVideos.map(video => {
          if (video.videoId === videoId) {
            return {
              ...video,
              isLiked: !video.isLiked,
              likeCount: video.isLiked ? video.likeCount - 1 : video.likeCount + 1
            };
          }
          return video;
        })
      );
    } catch (error) {
      console.error("error in likeDislike:", error);
    }
  };

  const handleCommentLikeDislike = async (videoId, commentId, action) => {
    const comment = comments.find(c => c.commentId === commentId);
    if (!comment) return;

    if (action === 'up' && comment.isLiked) return;
    if (action === 'down' && !comment.isLiked) return;

    if (!guardAnd()) return;
    const token = getToken();
    const userId = getUserId();
    
    try {
      const response = await likeDislike({ voteId: videoId, userId, targetId: commentId, targetType: 1 }, token);
      console.log("response from comment likeDislike api:", response);
      setComments(prevComments => {
        let updated = prevComments.map(c => {
          if (c.commentId === commentId) {
            return {
              ...c,
              isLiked: !c.isLiked,
              likeCount: c.isLiked ? Math.max(0, c.likeCount - 1) : c.likeCount + 1
            };
          }
          return c;
        });
        return updated.sort((a, b) => b.likeCount - a.likeCount);
      });
    } catch (error) {
      console.error("error in comment likeDislike:", error);
    }
  };

  const handleCommentIconClick = async (e, videoId) => {
    // Prevent event bubbling to avoid interference with click outside handler
    e.stopPropagation();

    // Set flag to prevent click outside handler from interfering
    isTogglingCommentRef.current = true;

    // Use a simple toggle approach - if it's open for this video, close it, otherwise open it
    if (openCommentVideoId === videoId) {
      // Close the comment box
      setOpenCommentVideoId(null);
      setComments([]);
    } else {
      // Open the comment box (close any other open comment first)
      try {
        const response = await getComments(videoId, getToken());
        console.log("response from getComments api:", response);
        const sortedComments = [...(response || [])].sort((a, b) => b.likeCount - a.likeCount);
        setComments(sortedComments);
        setOpenCommentVideoId(videoId);
      } catch (error) {
        console.error("error in getComments:", error);
      }
    }

    // Reset flag after a short delay
    setTimeout(() => {
      isTogglingCommentRef.current = false;
    }, 100);
  };

  const handleCommentSubmit = async () => {
    if (commentLoader) return;
    if (!guardAnd()) return;
    setCommentLoader(true);
    if (commentText.trim() === "") {
      return;
    }
    const token = getToken();
    const userId = getUserId();
    const credentials = {
      "userId": userId,
      "videoId": openCommentVideoId,
      "commentText": commentText
    }
    try {
      const response = await addComment(credentials, token);
      console.log("response from addComment api:", response);
      // Fetch updated comments
      const updatedComments = await getComments(openCommentVideoId, token);
      const sortedComments = [...(updatedComments || [])].sort((a, b) => b.likeCount - a.likeCount);
      setComments(sortedComments);

      // Update the comment count in shortsVideo state
      setShortsVideo(prevVideos =>
        prevVideos.map(video => {
          if (video.videoId === openCommentVideoId) {
            return {
              ...video,
              commentCount: video.commentCount + 1
            };
          }
          return video;
        })
      );
    } catch (error) {
      console.error("error in addComment:", error);
    } finally {
      setCommentLoader(false);
      setCommentText("");
    }
  }

  const handleDeleteComment = async (commentId) => {
    const token = getToken();
    const userId = getUserId();
    const credentials = {
      "userId": userId,
      "commentId": commentId
    }
    try {
      await deleteComment(credentials, token);

      // Fetch updated comments
      const updatedComments = await getComments(openCommentVideoId, token);
      const sortedComments = [...(updatedComments || [])].sort((a, b) => b.likeCount - a.likeCount);
      setComments(sortedComments);

      // Update the comment count in shortsVideo state
      setShortsVideo(prevVideos =>
        prevVideos.map(video => {
          if (video.videoId === openCommentVideoId) {
            return {
              ...video,
              commentCount: video.commentCount - 1
            };
          }
          return video;
        })
      );
    } catch (error) {
      console.error("error in deleteComment:", error);
    }
  };

  const handleShare = async (video) => {
    setSelectedVideoForShare(video);
    setShareDialogOpen(true);
  };

  const handleSystemShare = async () => {
    const shareUrl = `${window.location.origin}/shorts-video?videoId=${selectedVideoForShare.videoId}`;
    const shareData = {
      title: 'Share Video',
      text: selectedVideoForShare.description,
      url: shareUrl,
    };

    try {
      if (navigator.share) {
        await navigator.share(shareData);
      }
    } catch (error) {
      console.error('Error sharing:', error);
    }
    setShareDialogOpen(false);
  };

  const handleCopyLink = () => {
    const shareUrl = `${window.location.origin}/shorts-video?videoId=${selectedVideoForShare.videoId}`;
    navigator.clipboard.writeText(shareUrl).then(() => {
      setSnackbarMessage('Link copied to clipboard!');
      setSnackbarOpen(true);
      setShareDialogOpen(false);
    });
  };

  const handleVolumeToggle = (videoId, event) => {
    event.stopPropagation();
    setUnmutedVideoId(unmutedVideoId === videoId ? null : videoId);
  };

  const handleVoteVideoPlayPause = (voteId, event) => {
    event.stopPropagation();
    const videoElement = event.target.closest('.voteMediaContainer').querySelector('video');

    if (videoElement) {
      if (playingVoteVideos[voteId]) {
        videoElement.pause();
        setPlayingVoteVideos(prev => ({ ...prev, [voteId]: false }));
      } else {
        videoElement.play();
        setPlayingVoteVideos(prev => ({ ...prev, [voteId]: true }));
      }
    }
  };

  const handleFaceRecognitionSuccess = () => {
    setIsSignIn(true);
  };

  // Help popup handler functions
  const handleHelpClick = (e, cardId, creatorName, creatorUserId) => {
    e.preventDefault();
    e.stopPropagation();
    const rect = e.currentTarget.getBoundingClientRect();
    setPopupPosition({
      top: rect.bottom,
      left: rect.left - 200
    });
    console.log("creatorUserId:", creatorUserId);
    console.log("cardId:", cardId);
    setSelectedCardId(cardId);
    setSelectedCreatorName(creatorName);
    setSelectedCreatorUserId(creatorUserId);
    setShowPopup(true);
    setIsReportClicked(false);
  };

  const handleClickOutsidePopup = (e) => {
    if (e.target.className === 'popupOverlay') {
      setShowPopup(false);
    }
  };

  const handleReport = () => {
    setIsReportClicked(!isReportClicked);
  };

  const handleReportOption = (option) => {
    setShowPopup(false);
  };

  const handleVoteOptionClick = (voteId, optionId) => {
    setPendingVote({ voteId, optionId });
    setFaceRecognitionDialogOpen(true);
  };

  console.log("activeVoteDetails", activeVoteDetails);
  useEffect(() => {
    if (isSignIn && pendingVote) {
      const submit = async () => {
        const token = getToken();
        const userId = getUserId();
        try {
          const response = await submitVote({ voteId: pendingVote.voteId, userId, optionId: pendingVote.optionId }, token);
          console.log("submitVote response:", response);
          // Refetch the vote details to update percentages and isVoted
          const updatedDetails = await getVoteDetailsById({ voteId: pendingVote.voteId, userId }, token);
          setActiveVoteDetails(updatedDetails);
          setTimeout(() => {
            setActiveVoteDetails(null);
            // Restart the currently visible video
            const currentVideoId = visibleVideoId;
            if (currentVideoId) {
              const videoEl = videoRefs.current[currentVideoId];
              if (videoEl) {
                videoEl.currentTime = 0;
                videoEl.play().catch(error => console.log("Playback failed:", error));
              }
            }
          }, 1500); // Show result for 1.5s, then close
        } catch (error) {
          console.log("error", error);
        }
        setIsSignIn(false);
        setFaceRecognitionDialogOpen(false);
        setPendingVote(null);
      };
      submit();
    }
  }, [isSignIn, pendingVote]);

  // Snap to video function - similar to Instagram Reels
  const handleSnapToVideo = () => {
    if (!containerRef.current) return;

    const container = containerRef.current;
    const containerRect = container.getBoundingClientRect();
    const viewportHeight = containerRect.height;
    const halfViewport = viewportHeight / 2;

    let targetVideo = null;
    let bestScore = Infinity;

    // Find the video that should be snapped to based on the 50% rule
    Object.keys(videoRefs.current).forEach(videoId => {
      const videoElement = videoRefs.current[videoId];
      if (!videoElement) return;

      const videoContainer = videoElement.closest('.shortsVideoContainer2');
      if (!videoContainer) return;

      const videoRect = videoContainer.getBoundingClientRect();
      const containerTop = containerRect.top;
      const videoTop = videoRect.top - containerTop;
      const videoBottom = videoTop + videoRect.height;
      const videoCenter = videoTop + (videoRect.height / 2);

      // Check if video crosses the 50% threshold (center of viewport)
      const distanceFromCenter = Math.abs(videoCenter - halfViewport);

      // Prefer videos that are more centered and visible
      if (videoTop < viewportHeight && videoBottom > 0) {
        if (distanceFromCenter < bestScore) {
          bestScore = distanceFromCenter;
          targetVideo = { element: videoContainer, videoId, videoTop, videoCenter };
        }
      }
    });

    // If we found a target video and it's not already perfectly centered, snap to it
    if (targetVideo && bestScore > 20) { // 20px threshold to prevent unnecessary snapping
      const targetScrollTop = container.scrollTop + targetVideo.videoTop;

      container.scrollTo({
        top: targetScrollTop,
        behavior: 'smooth'
      });

      // Update the visible video ID
      setVisibleVideoId(targetVideo.videoId);
    }
  };

  // Debounced scroll handler
  const handleScroll = () => {
    // Close comment box and share dialog when scrolling starts
    if (openCommentVideoId) {
      setOpenCommentVideoId(null);
      setComments([]);
    }
    if (shareDialogOpen) {
      setShareDialogOpen(false);
      setSelectedVideoForShare(null);
    }

    if (!isScrollingRef.current) {
      isScrollingRef.current = true;
    }

    // Clear existing timeout
    if (scrollTimeoutRef.current) {
      clearTimeout(scrollTimeoutRef.current);
    }

    // Set new timeout to detect end of scrolling
    scrollTimeoutRef.current = setTimeout(() => {
      isScrollingRef.current = false;
      handleSnapToVideo();
    }, 150); // Wait 150ms after scrolling stops
  };

  // Close comment box and share dialog when vote container appears
  useEffect(() => {
    if (activeVoteDetails) {
      setOpenCommentVideoId(null);
      setComments([]);
      setShareDialogOpen(false);
      setSelectedVideoForShare(null);
    }
  }, [activeVoteDetails]);

  const handleDeleteShortsVideo = async (videoId) => {
    try {
      // const userId = getUserId();
      const token = getToken();
      const credentials = {
        // "userId": userId,
        "videoId": videoId
      };

      const response = await deleteShortsVideo(credentials, token);
      console.log("response from deleteShortsVideo api:", response);
      if (response.status === 200) {
        setShortsVideo(prevVideos =>
          prevVideos.filter(video => video.videoId !== videoId)
        );
        setSnackbarMessage("Video deleted successfully");
        setSnackbarOpen(true);
      }
      setShowPopup(false);
    } catch (error) {
      console.error("error in deleteShortsVideo:", error);
      setSnackbarMessage("Error deleting video");
      setSnackbarOpen(true);
    }
  };

  return (
    <div className="ShortsVideo">
      {activeVoteDetails && (
        <div className='votePopupContainer'>
          <div className="shorts-blur"></div>
          <div
            className="voteResponsePopup"
            style={{
              position: 'fixed',
              top: '54%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              background: '#222',
              color: '#fff',
              padding: '24px 32px',
              borderRadius: '12px',
              zIndex: 10000,
              boxShadow: '0 4px 24px rgba(0,0,0,0.3)',
              minWidth: '250px',
              textAlign: 'center',
              maxHeight: '70vh',
              height: 'auto',
              width: '30vw',
              overflow: 'auto',
              scrollbarWidth: 'thin',
              scrollbarColor: '#888 #222'
            }}
          >
            <button
              onClick={() => {
                // Store reference before clearing state
                const currentVideoId = visibleVideoId;

                setActiveVoteResponse(null);
                setActiveVoteDetails(null);

                // Restart the currently visible video
                if (currentVideoId) {
                  const videoEl = videoRefs.current[currentVideoId];
                  if (videoEl) {
                    videoEl.currentTime = 0;
                    videoEl.play().catch(error => console.log("Playback failed:", error));
                  }
                }
              }}
              style={{
                position: 'absolute',
                top: 8,
                right: 12,
                background: 'transparent',
                border: 'none',
                color: '#fff',
                fontSize: 30,
                cursor: 'pointer',
                zIndex: 10001,
              }}
            >
              ×
            </button>

            {/* Profile Section */}
            <div className="feedCardHeader" style={{ marginBottom: '20px' }}>
              <div className="profileDetailsContainer">
                {activeVoteDetails.createdByUserPhoto ? (
                  <img
                    src={activeVoteDetails.createdByUserPhoto}
                    alt="no-img-found"
                    className="profilePic"
                  />
                ) : (
                  <div
                    className="profilePic"
                    style={{
                      backgroundColor: getBackgroundColor(getUserInitials(activeVoteDetails.displayName)),
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                      fontWeight: 'bold',
                      fontSize: '16px',
                      fontFamily: 'Arial, sans-serif'
                    }}
                  >
                    {getUserInitials(activeVoteDetails.displayName)}
                  </div>
                )}
                <div className="profileDetails">
                  <span className="profileNameText">{activeVoteDetails.displayName ? activeVoteDetails.displayName : activeVoteDetails.createdByUserName}</span>
                </div>
              </div>
              <div className="timeContainer">
                {activeVoteDetails.isPaused ? <div className="pausedContainer"><span className="pausedtext">Paused</span></div> : <div className="timeContainer"><span className="timeText">{getHumanizedTime(activeVoteDetails.createdOn)}</span></div>}
              </div>
            </div>

            <div className="voteTitleContainer">
              <span className="voteTitleText">
                {activeVoteDetails.title}
              </span>
            </div>
            {activeVoteDetails.imageUrls?.[0] && <div className="voteMediaContainer" style={{ height: '60%' }}>
              <img
                src={activeVoteDetails.imageUrls[0] || "/Sidebar/voteImage.svg"}
                alt="no-img-found"
                style={{ width: '80%', height: '100%' }}
              />
            </div>}
            {activeVoteDetails.videoUrl && <div className="voteMediaContainer" style={{ position: 'relative' }}>
              <video
                src={activeVoteDetails.videoUrl}
                alt="no-video-found"
                muted
                loop
                onPlay={() => setPlayingVoteVideos(prev => ({ ...prev, [activeVoteDetails.voteId]: true }))}
                onPause={() => setPlayingVoteVideos(prev => ({ ...prev, [activeVoteDetails.voteId]: false }))}
                onClick={(e) => handleVoteVideoPlayPause(activeVoteDetails.voteId, e)}
                style={{
                  width: '80%',
                  height: '100%',
                  cursor: "pointer"
                }}
              />

              {/* Play/Pause Button Overlay */}
              {!playingVoteVideos[activeVoteDetails.voteId] && (
                <div
                  className="playPauseOverlay"
                  style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    cursor: 'pointer',
                    zIndex: 10
                  }}
                  onClick={(e) => handleVoteVideoPlayPause(activeVoteDetails.voteId, e)}
                >
                  <PlayArrowRoundedIcon
                    sx={{
                      color: "#5AAF9A",
                      fontSize: "70px",
                      cursor: "pointer",
                    }}
                  />
                </div>
              )}
            </div>}
            {activeVoteDetails.fileUrl && activeVoteDetails.fileUrl.endsWith('.pdf') && (
              <div className="pdfLinkContainer">
                <a
                  href={`https://drive.google.com/viewerng/viewer?url=${encodeURIComponent(activeVoteDetails.fileUrl)}&embedded=true`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="pdfLink"
                >
                  <img
                    src="/Assets/Sidebar/pdf-icon.svg"
                    alt="PDF"
                    className="pdfIcon"
                  />
                  View PDF
                </a>
              </div>
            )}

            <div className="voteDescriptionContainer" style={{ marginBottom: '20px' }}>
              <span className="voteDescriptionText">{activeVoteDetails.description}</span>
            </div>

            <div className="voteBtnsContainer">
              {activeVoteDetails.options.map((option) => (
                <button
                  key={option.id}
                  className={`vote-button-wrapper ${activeVoteDetails.isVoted ? 'voted' : ''} ${option.isSelected ? 'selected' : ''}`}
                  onClick={() => !activeVoteDetails.isVoted && handleVoteOptionClick(activeVoteDetails.voteId, option.id)}
                  disabled={activeVoteDetails.isVoted || activeVoteDetails.isPaused}
                >
                  {(activeVoteDetails.selectedOptionId).toLowerCase() === option.id && (
                    <div
                      className="vote-progress-bar"
                      style={{ width: `${option.percentage}%` }}
                    />
                  )}
                  <span className={`vote-text ${activeVoteDetails.isVoted ? 'voted' : ''}`}>{option.value}</span>
                  {activeVoteDetails.isVoted && (
                    <span className={`vote-percentage ${activeVoteDetails.isVoted ? 'voted' : ''}`}>{option.percentage}%</span>
                  )}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
      {isLoading ? (
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '80vh', width: '100%', gap: '20px' }}>
          <Loader containerSize="3rem" />
          <p style={{
            color: '#ffffff',
            fontWeight: '600',
            fontSize: '1rem',
            textTransform: 'uppercase',
            letterSpacing: '1.5px',
            textAlign: 'center',
            maxWidth: '90%',
            lineHeight: '1.4',
            fontFamily: '"Inter", sans-serif',
            opacity: 0.8
          }}>
            Hang tight, we’re getting things ready for you...
          </p>
        </div>
      ) : (
        <div
          className="shortsVideoContainer"
          ref={containerRef}
          onScroll={handleScroll}
        >
          {shortsVideo.map((item) => (
            <div className="shortsVideoContainer2" key={item.videoId}>
              <div className="videoContainer" style={{ position: 'relative' }}>
                <video
                  ref={el => videoRefs.current[item.videoId] = el}
                  data-video-id={item.videoId}
                  src={item.videoUrl}
                  muted={unmutedVideoId !== item.videoId}
                  playsInline
                  className='videoElement'
                  onEnded={() => {
                    // If this video should open a vote dialog
                    if (item?.voteId) {
                      setActiveVoteResponse(item.voteId);
                      console.log("item.voteResponse:", item);
                    } else {
                      // Otherwise, loop the video manually
                      const videoEl = videoRefs.current[item.videoId];
                      if (videoEl) {
                        videoEl.currentTime = 0;
                        videoEl.play();
                      }
                    }
                  }}
                />
                {visibleVideoId === item.videoId && (
                  <div className="infoContainer">
                    <div className="volumeControlContainer">
                      <InfoOutlineRoundedIcon
                        onClick={(e) => handleHelpClick(e, item.videoId, item.createdByUserName, item.createdByUser)}
                        sx={{
                          color: "#fff",
                          fontSize: { xs: "10px", sm: "13px", md: "15px", lg: "20px" },
                          cursor: "pointer",
                        }}
                      />
                    </div>
                    <div className="volumeControlContainer">
                      {unmutedVideoId === item.videoId ? (
                        <VolumeUpIcon
                          onClick={(e) => handleVolumeToggle(item.videoId, e)}
                          sx={{
                            color: "#fff",
                            fontSize: { xs: "10px", sm: "13px", md: "15px", lg: "20px" },
                            cursor: "pointer",
                            "&:hover": { opacity: 0.8 }
                          }}
                        />
                      ) : (
                        <VolumeOffIcon
                          onClick={(e) => handleVolumeToggle(item.videoId, e)}
                          sx={{
                            color: "#fff",
                            fontSize: { xs: "10px", sm: "13px", md: "15px", lg: "20px" },
                            cursor: "pointer",
                            "&:hover": { opacity: 0.8 }
                          }}
                        />
                      )}
                    </div>
                  </div>
                )}
                <div className='shortsVideoDetailsContainer'>
                  <div className='shortsVideoProfileDetails'>

                    {item.createdByUserPhoto !== null ? (
                      <div className='shortsVideoProfilePicContainer'>
                        <img src={item.createdByUserPhoto} alt="no-img-found" className='shortsVideoProfilePic' />
                      </div>
                    ) : (
                      <div
                        className="shortsVideoProfilePic"
                        style={{
                          backgroundColor: getBackgroundColor(getUserInitials(item.createdByUserName)),
                        }}
                      >
                        {getUserInitials(item.createdByUserName)}
                      </div>
                    )}
                    <div className='shortsVideoProfileNameContainer'>
                      <span className='shortsVideoProfileName'>{item.createdByUserName}</span>
                      <span className="videoCommentItemTime">{getHumanizedTime(item.createdAt)}</span>
                    </div>
                  </div>
                  <div className='shortsVideoDescriptionContainer'>
                    <span className='shortsVideoDescriptionText'>
                      {getTruncatedDescription(item.description, item.videoId)}
                    </span>
                    {item.description && item.description.length > 80 && (
                      <span
                        className="moreLessText"
                        onClick={() => toggleDescriptionExpansion(item.videoId)}
                      >
                        {expandedDescriptions[item.videoId] ? "  less" : "  more"}
                      </span>
                    )}
                  </div>
                </div>
                <div className='actionContainer'>
                  <div className={`actionItem ${item.isLiked ? 'liked' : ''}`} onClick={() => handleLikeDislike(item.videoId)}>
                    {item.isLiked ? (
                      <FavoriteRoundedIcon sx={{ color: "#FF0000", fontSize: { xs: "15px", md: "20px", sm: "15px", lg: "25px" } }} />
                    ) : (
                      <FavoriteBorderRoundedIcon sx={{ color: "#fff", fontSize: { xs: "15px", md: "20px", sm: "15px", lg: "25px" } }} />
                    )}
                    <span className={`countText ${item.isLiked ? 'liked-text' : ''}`}>{item.likeCount}</span>
                  </div>
                  <div className='actionItem'>
                    <ChatBubbleOutlineRoundedIcon sx={{ color: "#fff", fontSize: { xs: "15px", md: "20px", sm: "15px", lg: "25px" } }} onClick={(e) => {
                      handleCommentIconClick(e, item.videoId);
                    }}
                    />
                    <span className='countText'>{item.commentCount}</span>
                  </div>
                  <div className='actionItem'>
                    <div className="voteShareContainer">
                      <NearMeOutlinedIcon sx={{ color: "#fff", fontSize: { xs: "15px", md: "20px", sm: "15px", lg: "25px" } }} onClick={() => handleShare(item)} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Comment Container - Outside scrolling container to prevent clipping */}
      {openCommentVideoId && (
        <div
          className='commentDialogContainer'
          ref={commentBoxRef}
          onClick={(e) => e.stopPropagation()} // Prevent clicks inside from closing
        >
          <div className='commentHeaderContainer'>
            <div className='commentHeaderLeft'>
              <span className='commentHeaderText'>Comments</span>
              <span className='commentHeaderBadge'>{comments.length}</span>
            </div>
            <button
              type='button'
              className='commentCloseBtn'
              onClick={() => {
                setOpenCommentVideoId(null);
                setComments([]);
              }}
              aria-label='Close comments'
            >
              <CloseIcon sx={{ fontSize: '18px' }} />
            </button>
          </div>

          <div className='commentContentContainer'>
            {comments.length === 0 && (
              <div className='noCommentContainer'>
                <div className='noCommentIconWrapper'>
                  <ChatBubbleOutlineRoundedIcon sx={{ fontSize: '26px', color: '#5AAF9A' }} />
                </div>
                <span className='noCommentsTitle'>No comments yet</span>
                <span className='noCommentsSubtitle'>Be the first to share your thoughts!</span>
              </div>
            )}
            {comments.length > 0 && comments.map((comment) => (
              <div key={comment.commentId} className='videoCommentItem'>
                {comment.userPhoto ? (
                  <img src={comment.userPhoto} alt={comment.userName} className='videoCommentItemProfilePic' />
                ) : (
                  <div
                    className="videoCommentItemProfilePic"
                    style={{
                      backgroundColor: getBackgroundColor(getUserInitials(comment.userName)),
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                      fontWeight: 'bold',
                      fontSize: '13px',
                      fontFamily: 'Satoshi, sans-serif'
                    }}
                  >
                    {getUserInitials(comment.userName)}
                  </div>
                )}
                <div className='videoCommentItemTextContainer'>
                  <div className='videoCommentItemHeader'>
                    <span className='videoCommentItemUserName'>{comment.userName}</span>
                    <span className='videoCommentItemTime'>{getHumanizedTime(comment.createdAt)}</span>
                  </div>
                  <span className='videoCommentItemCommentText'>{comment.commentText}</span>
                  <div className="commentActionsRow" style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '6px' }}>
                    <div className='commentVotePill'>
                      <KeyboardArrowUpRoundedIcon 
                        sx={{ 
                          color: comment.isLiked ? "#5AAF9A" : "#808080", 
                          fontSize: "18px", 
                          cursor: comment.isLiked ? "default" : "pointer",
                          "&:hover": { color: "#5AAF9A" }
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCommentLikeDislike(openCommentVideoId, comment.commentId, 'up');
                        }}
                      />
                      <span className='commentVoteCount'>
                        {comment.likeCount || 0}
                      </span>
                      <KeyboardArrowDownRoundedIcon 
                        sx={{ 
                          color: !comment.isLiked ? "#808080" : "#808080",
                          fontSize: "18px", 
                          cursor: !comment.isLiked ? "default" : "pointer",
                          "&:hover": { color: "#ffffff" }
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCommentLikeDislike(openCommentVideoId, comment.commentId, 'down');
                        }}
                      />
                    </div>
                  </div>
                </div>
                {comment.userId === getUserId() && (
                  <DeleteOutlineRoundedIcon
                    className='deleteCommentIcon'
                    sx={{
                      color: "rgba(255, 255, 255, 0.4)",
                      fontSize: { xs: "15px", md: "18px" },
                      cursor: "pointer",
                      "&:hover": { color: "#E57373" }
                    }}
                    onClick={() => handleDeleteComment(comment.commentId)}
                  />
                )}
              </div>
            ))}
          </div>

          <div className='commentShortsInputContainer'>
            <div className='commentInputWrapper'>
              <input
                type='text'
                className='commentInput'
                placeholder='Add a comment...'
                onChange={(e) => setCommentText(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    handleCommentSubmit();
                  }
                }}
                value={commentText}
              />
              <button
                type='button'
                className={`shortsCommentSendBtn ${commentText.trim() ? 'active' : ''}`}
                onClick={handleCommentSubmit}
                disabled={!commentText.trim() || commentLoader}
                aria-label='Send comment'
              >
                <SendRoundedIcon sx={{ fontSize: '16px' }} />
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Share Dialog */}
      <ShareModal
        open={shareDialogOpen}
        onClose={() => setShareDialogOpen(false)}
        item={selectedVideoForShare}
        shareType="short"
        onToast={(msg) => {
          setSnackbarMessage(msg);
          setSnackbarOpen(true);
        }}
      />

      {/* Snackbar for copy confirmation */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />
      <SubscriptionPrompt
        open={subscriptionDialogOpen}
        onClose={() => setSubscriptionDialogOpen(false)}
        message={"Please purchase a subscription from the Android or iOS app to like or comment on shorts."}
      />
      <ProfileCompletionPrompt
        open={profilePromptOpen}
        onClose={() => setProfilePromptOpen(false)}
        message={profilePromptMessage || "Please complete your profile (name, date of birth, and address) to continue."}
        actionLabel="GOT IT"
        secondaryAction={null}
        onPrimaryAction={() => setProfilePromptOpen(false)}
      />
      <Dialog
        open={faceRecognitionDialogOpen}
        onClose={() => setFaceRecognitionDialogOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            width: '50vw',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 3,
            overflow: 'hidden',
            marginTop: '150px',
            backgroundColor: '#0e1b1b',
            position: 'relative',
          }
        }}
      >
        <DialogTitle sx={{ color: 'white', width: '100%', pr: 5, pl: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          Verify your identity
          <CloseIcon
            onClick={() => setFaceRecognitionDialogOpen(false)}
            sx={{
              position: 'absolute',
              right: 16,
              top: 16,
              color: 'white',
              cursor: 'pointer',
              fontSize: 28,
              zIndex: 10,
            }}
            aria-label="close"
          />
        </DialogTitle>
        <FaceRecognition
          isUserVerified={isUserVerified}
          onSuccess={handleFaceRecognitionSuccess}
          onCancel={() => setFaceRecognitionDialogOpen(false)}
        />
      </Dialog>

      {/* Help Popup */}
      {showPopup && (
        <div className="popupOverlay" onClick={handleClickOutsidePopup}>
          <div
            className="popupContent"
            style={{
              top: `${popupPosition.top}px`,
              left: `${popupPosition.left}px`
            }}
          >
            <span className="popupTitle">Information</span>
            {selectedCreatorUserId !== getUserId() && (
              <button className="popupBtn saveBtn">
                <PermIdentityRoundedIcon sx={{ color: "#BD564E", fontSize: { xs: "15px", md: "20px", sm: "15px", lg: "25px" } }} />
                <span className="reportBtnText">Request Block {selectedCreatorName}</span>
              </button>
            )}
            <button className="popupBtn reportBtn" onClick={handleReport}>
              <img src="/Assets/Sidebar/reportIcon.svg" alt="no-img-found" className="informationBtnIcon" />
              <span className="reportBtnText">Report this content</span>
            </button>
            {selectedCreatorUserId == getUserId() && (
              <button className="popupBtn saveBtn" onClick={(e) => handleDeleteShortsVideo(selectedCardId)}>
                <DeleteRoundedIcon sx={{ color: "#BD564E", fontSize: { xs: "15px", md: "20px", sm: "15px", lg: "25px" } }} />
                <span className="reportBtnText">Delete</span>
              </button>
            )}
            {isReportClicked && <div className="reportReasonContainer">
              <span className="informationBtnText">Select a reason</span>
              <div className="reportReasonOptions">
                <span className="reportReasonOption" onClick={handleReportOption}>Harmful or Dangerous Content</span>
                <span className="reportReasonOption" onClick={handleReportOption}>Harrasment or Hate Speech</span>
                <span className="reportReasonOption" onClick={handleReportOption}>Sexual or Inappropriate Content</span>
                <span className="reportReasonOption" onClick={handleReportOption}>Spam or misleading</span>
                <span className="reportReasonOption" onClick={handleReportOption}>Violent or Graphic Content</span>
                <span className="reportReasonOption" onClick={handleReportOption}>Other</span>
              </div>
            </div>}
          </div>
        </div>
      )}
    </div>
  );
};

export default ShortsVideo;

